import React from "react";
import { Plus, Download, Edit, Minus, Send } from "lucide-react";
import { Icon } from "src/enums/icon";

interface IconButtonProps {
  icon: keyof typeof Icon;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  size?: "sm" | "md" | "lg";
}

const IconButton: React.FC<IconButtonProps> = ({ onClick, icon, disabled = false, className = "", size = "md" }) => {
  const sizeClasses = {
    sm: "w-7 h-7",
    md: "w-9 h-9",
    lg: "w-11 h-11"
  };

  const iconSizeClasses = {
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6"
  };

  let IconComponent: React.ComponentType<{ className?: string }> | null = null;

  switch (icon) {
    case "ADD":
      IconComponent = Plus;
      break;
    case "DOWNLOAD":
      IconComponent = Download;
      break;
    case "EDIT":
      IconComponent = Edit;
      break;
    case "MINUS":
      IconComponent = Minus;
      break;
    case "SEND":
      IconComponent = Send;
      break;
  }

  const baseClasses = [
    sizeClasses[size],
    "flex items-center justify-center",
    "rounded-lg",
    "bg-white border border-secondary-200",
    "text-secondary-700",
    "transition-all duration-200",
    "hover:bg-secondary-50 hover:border-secondary-300",
    "focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2",
    "disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:border-secondary-200",
    className
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button onClick={onClick} type="button" disabled={disabled} className={baseClasses}>
      {IconComponent && <IconComponent className={iconSizeClasses[size]} />}
    </button>
  );
};

export { IconButton };
